import { ChatRoom } from '@types';
import { atom } from 'recoil';

export const ChatRoomsAtom = atom<{ [participantId: string]: ChatRoom } | null>({
  key: 'ChatRoomsAtom',
  default: null,
  dangerouslyAllowMutability: true,
});
